
import Component from 'vue-class-component';
import { Prop, PropSync } from 'vue-property-decorator';
import type {
  Unit, Onset, Pixel, Second,
} from '@/data';
import { PixelUnitWithSeconds } from '@/data';
import PixelUtils from '@/data/PixelUtils';
import type { Image3DPageData } from '@/data/Source';
import LabelBehavior from '../LabelBehavior.vue';

/**
 * Set player position using shift click
 */
@Component
export default class BSeekOnShiftClick extends LabelBehavior {
  mounted() {
    this.register('staff-shift-mousedown', (e) => {
      if (PixelUnitWithSeconds.isUnitWithSeconds(this.pixelUnit)) {
        this.realTime = this.pixelUnit.fromPixelToSecond(
          PixelUtils.getMuxPixelFromPosition(this.pages, e.x, e.y),
        );
      } else {
        this.musicalTime = this.pixelUnit
          .toOnset(PixelUtils.getMuxPixelFromPosition(this.pages, e.x, e.y)).value;
      }
    });
    this.register('label-shift-mousedown', (e, label) => {
      this.musicalTime = label.onset;
    });
  }

  @Prop()
  pixelUnit!: Unit<Pixel>;

  @PropSync('time', { required: false })
  musicalTime!: Onset;

  @PropSync('realTimeSync', { required: false })
  realTime!: Second;

  @Prop()
  pages!: Array<Image3DPageData>;
}
